import {Navigate} from "react-router-dom";

export default function PrivateRoute({ redirectPath = '/login', children}) {
  if (!localStorage.getItem('userToken')) {
    return <Navigate to={redirectPath} />;
  }

  return children;
}
